module.exports = __webpack_public_path__ + "assets/img/img-feature3-3c9a7080.jpg";